/**
 * Get how the data was stored.
 * @param flagParameters - flag parameters from the file header.
 * @param flagParameters.multiFile - whether there are multiple spectra (subfiles) or not.
 * @param flagParameters.xy - uneven x values.
 * @param flagParameters.xyxy - multifile with separate x axis.
 * @returns the shape of the data as a string.
 */
export function getDataShape({ multiFile, xy, xyxy, }) {
    /*
    single file
    */
    if (!multiFile) {
        // Y or XY,
        return !xy ? 'Y' : xyxy ? 'exception' : 'XY';
    }
    /*
    then multifile
    */
    if (!xy) {
        /*
        even X - equidistant
        */
        return 'YY';
    }
    // uneven x
    return !xyxy ? 'XYY' : 'XYXY';
}
//# sourceMappingURL=getDataShape.js.map